import { useState, useEffect, useCallback } from "react";

export const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState({ 
    open: false, 
    message: "", 
    severity: "info",
    emoji: "",  
    duration: 5000 
  });
  const [bottomNavHeight, setBottomNavHeight] = useState(0);

  // 🔍 Mesure dynamique de la hauteur du footer
  useEffect(() => {
    const nav = document.querySelector('.MuiBottomNavigation-root');
    if (nav) {
      const updateHeight = () => setBottomNavHeight(nav.offsetHeight);
      updateHeight();
      window.addEventListener('resize', updateHeight);
      return () => window.removeEventListener('resize', updateHeight);
    }
  }, []);

  // ✅ Méthode pour déclencher le snackbar
  const showSnackbar = useCallback(({ message, severity = "info", emoji = "" }) => {
    setSnackbar(prev => ({
      ...prev,          // 👈 garde duration, etc.
      open: true, 
      message, 
      severity,
      emoji  
      }));
  }, []);

  return { snackbar, setSnackbar, bottomNavHeight, showSnackbar };
};
